import { useState } from 'react';
import { FilterPriceRegionModal } from '@/components/Modals/FilterPriceRegionModal';
import { IPricingComparative } from '@/types/api/pricingsComparativeRegion';
import {
  ListItem,
  ListItemButton,
  ListItemIcon,
  ListItemText,
  Radio,
} from '@mui/material';

interface IItemComparativeFilterModalProps {
  isOpen: boolean;
  handleClose: () => void;
  items: Array<IPricingComparative & { selected: boolean }>;
  onChangeItem: (id: number) => void;
}

const ItemComparativeFilterModal = ({
  isOpen,
  handleClose,
  items,
  onChangeItem,
}: IItemComparativeFilterModalProps) => {
  const [search, setSearch] = useState('');
  const [itemSelected, setItemSelected] = useState(
    items.find(item => item.selected)?.id.toString() || ''
  );

  return (
    <FilterPriceRegionModal
      title="Itens"
      inputLabel="Pesquise por item"
      open={isOpen}
      handleClose={handleClose}
      selectOption={itemSelected}
      onFilter={value => setSearch(value)}
      setOption={id => onChangeItem(Number(id))}
    >
      <>
        {items
          .filter(item =>
            search
              ? item.name.toLowerCase().includes(search.toLowerCase())
              : !search
          )
          .map(item => (
            <ListItem key={item.id} disablePadding>
              <ListItemButton
                onClick={() => setItemSelected(item.id.toString())}
                dense
              >
                <ListItemIcon>
                  <Radio
                    edge="start"
                    checked={item.id === Number(itemSelected)}
                  />
                </ListItemIcon>
                <ListItemText primary={item.name} />
              </ListItemButton>
            </ListItem>
          ))}
      </>
    </FilterPriceRegionModal>
  );
};

export default ItemComparativeFilterModal;
export type { IItemComparativeFilterModalProps };
